/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class MonitorReviewsReceivedConversationIssueNewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.reviews.received.conversation.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(MonitorReviewsReceivedConversationIssueNewRoute);
